module.exports = __webpack_public_path__ + "static/media/centro_platea_2(1).65cc5355.jpg";